module.exports = __webpack_public_path__ + "static/media/3.dfc19a57.png";